<ng-container
    *ngIf="
        serviceTimes != null &&
        (serviceTimes.components.length > 0 || serviceTimes.total != null)
    "
>
    <h4 class="section-heading">
        <span *ngIf="timeInServiceMode === 'TOTAL'">Total Time In Service</span>
        <span *ngIf="timeInServiceMode === 'MAINTENANCE'"
            >Time In Service at Maintenance Request</span
        >
        <div></div>
    </h4>
    <enhanced-help
        componentName="component-service-time"
        [compact]="true"
    ></enhanced-help>

    <!-- If the resource has no components, then only show its total time in service -->
    <ng-container
        *ngIf="
            serviceTimes.components.length === 0 && serviceTimes.total != null
        "
    >
        <div class="fcol-8">
            <div class="fill table-container no-actions">
                <table class="table">
                    <thead>
                        <tr>
                            <th style="width: 15%"></th>
                            <th style="width: 15%">Time</th>
                            <th style="width: 15%">Cycles</th>
                            <!-- <th style="width: 15%">Last used</th> -->
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                <strong>Total</strong>
                            </td>
                            <td>
                                {{
                                    serviceTimes.total.time
                                        | formatDuration
                                        | defaultTo
                                }}
                            </td>
                            <td>
                                {{ serviceTimes.total.cycles }}
                            </td>
                            <!-- <td>
                                {{
                                    serviceTimes.total.timestamp
                                        | formatDateTime
                                }}
                            </td> -->
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </ng-container>

    <!-- If the resource has components, then show them all -->
    <ng-container *ngIf="serviceTimes.components.length > 0">
        <div
            *ngIf="timeInServiceMode === 'TOTAL' && hasScheduledMaintenance"
            class="horizontal-container pad-children bottom-buffer"
        >
            <span class="display-label">Scheduled Maintenance Status</span>
            <maintenance-trigger-type
                [alwaysShow]="true"
                [type]="serviceTimes?.triggerStatus?.type"
            ></maintenance-trigger-type>
        </div>
        <div class="vertical-scroll horizontal-container bottom-buffer">
            <div class="fcol-8">
                <div class="fill table-container no-actions">
                    <table class="table">
                        <thead>
                            <tr *ngIf="hasScheduledMaintenance">
                                <th style="width: 15%">Component Group</th>
                                <th style="width: 15%">Designation</th>
                                <th style="width: 15%">Serial Number</th>
                                <th style="width: 15%">Firmware Version</th>
                                <th style="width: 15%">
                                    Total time in service&nbsp;
                                    <i
                                        class="fal fa-info-circle info-tooltip"
                                        [tooltip]="
                                            'Unless component has been replaced during maintenance, days in service are calculated from the ' +
                                            (resourceType === 'CRAFT'
                                                ? 'RPA'
                                                : 'equipment') +
                                            '\'s estimated procurement date'
                                        "
                                        placement="top"
                                    ></i>
                                </th>
                                <th style="width: 15%">
                                    Time until next maintenance
                                </th>
                            </tr>
                            <tr *ngIf="!hasScheduledMaintenance">
                                <th style="width: 15%">Component Group</th>
                                <th style="width: 15%">Designation</th>
                                <th style="width: 15%">Serial Number</th>
                                <th style="width: 15%">Firmware Version</th>
                                <th style="width: 20%">
                                    Total time in service
                                </th>
                            </tr>
                        </thead>
                        <tbody *ngIf="!working">
                            <ng-container
                                *ngFor="let componentType of tableComponents"
                            >
                                <label>{{
                                    componentType.componentTypeName
                                }}</label>
                                <ng-container
                                    *ngFor="
                                        let component of componentType.components;
                                        let i = index
                                    "
                                >
                                    <tr
                                        class="data"
                                        (mouseover)="
                                            getAttachmentUrl(component)
                                        "
                                    >
                                        <td>
                                            <span
                                                *ngIf="
                                                    findComponentIcon(
                                                        component
                                                    );
                                                    let componentIconClass
                                                "
                                                [class]="componentIconClass"
                                            ></span
                                            >{{
                                                component.componentGroup
                                                    ?.name ||
                                                    component.componentType.name
                                            }}
                                        </td>
                                        <td>
                                            {{ component.designation }}
                                        </td>
                                        <td>
                                            {{ component.serialNumber }}
                                        </td>
                                        <td>
                                            {{ component.firmwareVersion }}
                                        </td>
                                        <td>
                                            <span
                                                *ngIf="component.total != null"
                                                [innerHtml]="
                                                    component.total
                                                        | formatInServiceTime
                                                "
                                            >
                                            </span>
                                        </td>
                                        <td *ngIf="hasScheduledMaintenance">
                                            <maintenance-trigger-type
                                                [type]="component.triggerType"
                                                layout="INDICATOR"
                                            ></maintenance-trigger-type>
                                            <span
                                                *ngIf="
                                                    component.untilMaintenanceSchedule !=
                                                    null
                                                "
                                                class="left-buffer"
                                                [innerHtml]="
                                                    component.untilMaintenanceSchedule
                                                        | formatInServiceTime
                                                            : 'UNTIL'
                                                            : until
                                                "
                                            >
                                            </span>
                                        </td>
                                    </tr>
                                </ng-container>
                            </ng-container>
                        </tbody>
                    </table>
                </div>
            </div>
            <div
                class="fcol-4"
                style="
                    display: flex;
                    align-items: center;
                    justify-content: center;
                "
            >
                <img
                    *ngIf="diagramUrl != null"
                    style="max-width: 300px; height: auto"
                    [authenticatedSrc]="diagramUrl"
                    [cache]="false"
                />
            </div>
        </div>
    </ng-container>
</ng-container>
